import * as React from "react";
import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";
import Panel from "../Panel/Panel";

interface IProps {
  title: string;
}

const LockedWidget = ({ title }: IProps) => {
  const { t } = useTranslation();

  return (
    <Panel
      className="h-full flex flex-col mb-0!"
      contentClasses="min-h-0 flex-1 flex flex-col items-center justify-center gap-2 text-center text-muted-foreground"
      title={title}
    >
      <Lock className="size-6" />
      <p>{t("Dashboard::You don't have the required permissions to view this information")}</p>
    </Panel>
  );
};

export default LockedWidget;
